import React from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";

const CustomCKEditor = ({ data, onChange, placeholder = "Background" }) => {
  return (
    <CKEditor
      editor={Editor}
      config={{
        fontSize: {
          options: [
            9, 11, 13, "default", 17, 19, 21, 24, 28, 32, 36, 38, 42,
          ],
        },
        placeholder,
      }}
      data={data}
      onChange={(event, editor) => onChange(editor.getData())}
    />
  );
};

export default CustomCKEditor;